import { Component, Inject, OnInit, LOCALE_ID, ViewChild, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { jsPDF } from 'jspdf';
import { DatePipe, registerLocaleData } from '@angular/common';
import localEs from '@angular/common/locales/es';
import { AuthService } from './../../../../views/auth/auth.service';
import { MapaConsolaService } from '../../services/mapa-consola.service';
import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';
import { ToastrService } from 'ngx-toastr';
import html2canvas from 'html2canvas';

registerLocaleData(localEs, 'es')

@Component({
	selector: 'kt-imprimir-pdf',
	templateUrl: './imprimir-pdf.component.html',
	styleUrls: ['./imprimir-pdf.component.scss'],
	providers: [{
		provide: LOCALE_ID, useValue: 'es-MX'
	}]
})
export class ImprimirPdfComponent implements OnInit {
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent

	public fecha: string;
	public vehiculosData: any;
	public maxLength = null;
	public lugar: string;
	public situacion: string;
	public contacto: string;
	public usuario: string;
	public inicioLlamada: Date;
	public finLlamada: Date;
	public mensaje: string = 'El motivo del presente reporte es informar que uno de sus vehículos se alarmó, por tal motivo le enviamos todos los datos:'
	public imagenMapa;
	public loadingVisible: boolean = false;


	constructor(private userService: AuthService,
		private mapaConsolaService: MapaConsolaService,
		private toastService: ToastrService,
		private dialogRef: MatDialogRef<ImprimirPdfComponent>,
		private datepipe: DatePipe,
		@Inject(MAT_DIALOG_DATA) public data: any) { }

	ngOnInit() {
		this.obtenerLugar();
		this.fecha = this.datepipe.transform(new Date(), 'EEEE, d MMMM y', '', 'es-MX');
		this.mapaConsolaService.inicializarMapa()
		this.mapaConsolaService.pintarMarcadores(this.data);
		this.vehiculosData = this.data;
		this.usuario = this.userService.getUser().nombreCompleto;
		var botonesRecorrido = document.getElementById('botonesRecorrido');
		botonesRecorrido.style.display = 'block';
	}

	imprimirPdf() {
		if (this.validationGroup.instance.validate().isValid) {
			this.loadingVisible = true;
			var mapElement = document.getElementById('map-marker');
			html2canvas(mapElement, { useCORS: true }
			).then((canvas) => {

				var pdf = new jsPDF('p', 'pt', 'a4');
				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 130;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;

				let dir = '';
				let dir2= '';

				const fragmentDirection = this.lugar.split(',');
				let cont = 0;
				while (cont <= 1) {
					dir = dir + fragmentDirection[cont] + ', '
					cont++;
				}

				while (cont < fragmentDirection.length) {
					dir2 = dir2 + fragmentDirection[cont] + ', '
					cont++;
				}


				const logoGTM = './assets/media/logos/logo-gtm.png'
				const logoGTMX = 20;
				const logoGTMY = 15;
				const logoGTMWidth = 180;
				const logoGTMHeight = 80;

				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');


				const logoGTMWater = './assets/media/logos/marca-de-agua.png'
				const logoGTMWaterX = 15;
				const logoGTMWaterY = 130;
				const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
				const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
				const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
				pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

				pdf.setFontSize(14);
				pdf.setFont('sans-serif', 'bold')
				pdf.text(this.fecha, 410, 110);

				pdf.setFontSize(18);
				pdf.text(this.vehiculosData.nombreCliente, 40, 150);
				pdf.setFontSize(12);

				pdf.setFont('sans-serif', 'normal')
				pdf.text('A quien corresponda', 40, 165);
				pdf.text('Presente,', 40, 205);
				pdf.text('El motivo del presente reporte es informar que uno de sus vehículos se alarmó, por tal motivo le', 40, 220);
				pdf.text('enviamos todos los datos:', 40, 235);

				pdf.setFont('sans-serif', 'bold')
				pdf.text('Datos del Vehículo:', 40, 280);

				pdf.setFont('sans-serif', 'normal')
				pdf.text('Vehículo:', 40, 295);
				pdf.text(this.vehiculosData.marca + ', ' + this.vehiculosData.modelo, 250, 295);

				pdf.text('Económico:', 40, 310);
				pdf.text(this.vehiculosData.economico, 250, 310);

				pdf.text('Placas:', 40, 325);
				pdf.text(this.vehiculosData.placas, 250, 325);

				pdf.text('Fecha y Hora:', 40, 340);
				pdf.text(this.vehiculosData.fechaHora, 250, 340);

				pdf.text('Situación:', 40, 355);
				pdf.text(this.situacion, 250, 355);

				pdf.text('Contacto:', 40, 370);
				pdf.text(this.contacto, 250, 370);

				pdf.text('Inicio de Llamada:', 40, 385);
				pdf.text(this.datepipe.transform(this.inicioLlamada, 'hh:mm a'), 250, 385);

				pdf.text('Fin de Llamada:', 40, 400);
				pdf.text(this.datepipe.transform(this.finLlamada, 'hh:mm a'), 250, 400);

				pdf.text('Lugar:', 40, 415);
				pdf.text(dir, 250, 415);
				pdf.text(dir2, 35, 430);

				pdf.text('Sin más por el momento, estoy a sus órdenes', 40, 580);
				pdf.text('A T E N T A M E N T E', 40, 610);
				pdf.setFont('sans-serif', 'bold')
				pdf.text(this.usuario, 40, 625);
				pdf.text('Monitoreo', 40, 640);
				pdf.text('GTM Tecnolgía S.A. de C.V.', 40, 655);

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				pdf.addPage();
				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				return pdf;
			}).then(
				(pdf) => {
					const fechaHora = this.vehiculosData.fechaHora.split(' ');
					let fecha = fechaHora[0].replaceAll('/', '');
					const hora = fechaHora[1].replaceAll(':', '');
					let nombreArchivo = this.vehiculosData.nombreCliente + ' ' + this.vehiculosData.economico + ' ' + fecha + ' ' + hora;
					pdf.save(nombreArchivo + '.pdf');
					this.loadingVisible = false;
				});

		} else {
			this.toastService.error('Existe uno o mas campos vacios')
		}
	}

	obtenerLugar() {
		this.mapaConsolaService.getDireccion([this.data.lng, this.data.lat]).then(
			(data: any) => {
				this.lugar = data.display_name || "Dirección Desconocida";
			},
			() => {
				this.lugar = "Dirección Desconocida";
			}
		);
	}


	roadmap() {
		this.mapaConsolaService.roadmap();
	}

	hybrid() {
		this.mapaConsolaService.hybrid();
	}

	cerrarPopup() {
		this.dialogRef.close()
	}

	maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

}
